module.exports = __webpack_public_path__ + "img/scene1-4.8cf0e98b.png";